var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgBackArrow = function SvgBackArrow(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.75338 13.2042C7.14204 12.8797 7.19521 12.3022 6.87071 11.9135L3.54046 7.91688L14.4167 7.91688C14.9227 7.91688 15.3334 7.50622 15.3334 7.00022C15.3334 6.49422 14.9227 6.08355 14.4167 6.08355L3.54046 6.08355L6.87071 2.08688C7.19521 1.6973 7.14204 1.1198 6.75338 0.796215C6.36471 0.471715 5.78629 0.523965 5.46271 0.913548L0.879375 6.41355C0.84271 6.45663 0.825292 6.50797 0.797791 6.55563C0.775792 6.59322 0.750126 6.62622 0.733625 6.66747C0.691459 6.77472 0.666709 6.88655 0.666709 7.00022C0.666709 7.11388 0.691459 7.22572 0.733625 7.33297C0.750126 7.37422 0.775792 7.40722 0.797791 7.4448C0.825292 7.49247 0.84271 7.5438 0.879375 7.58688L5.46271 13.0869C5.78629 13.4755 6.36471 13.5287 6.75338 13.2042Z",
    fill: "#18379A"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBackArrow, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/back-arrow.4f6d2726.svg";
export { ForwardRef as ReactComponent };